// 3 PACK JS STARTS

const mainPack = document.getElementById("pack-products");
const mainPackoptions = document.querySelectorAll(".pack-option");
const gridPackTitle = document.getElementById("grid-pack-title");
const stickyPackTitle = document.getElementById("sticky-bar-qty");
const stickyInitial = document.getElementById("initial-count");
const packCheckout = document.getElementById("bundle-pack__checkout");
const packDiscount = document.getElementById("bundle-pack__discount");
const slots = document.querySelectorAll(".bundle-pack__slot_inner");
const packMainPrice = document.getElementById("pack-original-price");
const packSalePrice = document.getElementById("pack-discounted-price");
const variantPackoptions = document.querySelectorAll(".custom-pack-variant-selector");
const variantPackQty = document.querySelectorAll(".quantity-selector__button");

let selectedVariantIds = []; 

function showSlots(count) {
  slots.forEach((slot, index) => {
    slot.style.display = index < count ? "flex" : "none";
  });
}

function recalcBundleTotals() {
  let totalPrice = 0; 
  let totalCompare = 0; 

  selectedVariantIds.forEach(entry => {
    const slot = slots[entry.slot];
    if (!slot) return;

    const removeBtn = slot.querySelector(".custom-remove-pack");
    if (!removeBtn) return;

    const price = parsePrice(removeBtn.getAttribute("data-price"));
    const comparePrice = parsePrice(removeBtn.getAttribute("data-compare-price"));

    totalPrice += price;

    if (comparePrice && comparePrice > 0) {
      totalCompare += comparePrice;   // discounted product → use compare price
    } else {
      totalCompare += price;          // no discount → fall back to normal price
    }
  });

  const save = totalCompare - totalPrice;
  const packSaveSpan = document.getElementById("pack-footer-save-value-span");

  if(save === 0){
    packMainPrice.classList.add("hidden");
    packSaveSpan.style.display = "none";
  } else {
    packMainPrice.classList.remove("hidden");
    packSaveSpan.style.display = "flex";
  }

  if (packMainPrice) packMainPrice.innerText = formatCurrency(totalCompare);
  if (packSalePrice) packSalePrice.innerText = formatCurrency(totalPrice);

  const packSaveValue = document.getElementById("pack-footer-save-value");
  if (packSaveValue) {
    packSaveValue.innerText = save > 0 ? "-" + formatCurrency(save) : "";
  }
}

// function recalcBundleTotals() {
//   let totalPrice = 0; // discounted / sale price
//   let totalCompare = 0; // original / compare-at price

//   selectedVariantIds.forEach(entry => {
//     const slot = slots[entry.slot];
//     if (!slot) return;

//     const removeBtn = slot.querySelector(".custom-remove-pack");
//     if (!removeBtn) return;

//     const price = parsePrice(removeBtn.getAttribute("data-price"));
//     const comparePrice = parsePrice(removeBtn.getAttribute("data-compare-price"));

//     totalPrice += price;
//     totalCompare += comparePrice;
//   });

//   const save = totalCompare - totalPrice;

//   if (packMainPrice) packMainPrice.innerText = formatCurrency(totalCompare);
//   if (packSalePrice) packSalePrice.innerText = formatCurrency(totalPrice);

//   const packSaveValue = document.getElementById("pack-footer-save-value");
//   if (packSaveValue) packSaveValue.innerText = "-" + formatCurrency(save);
// }

// Utility to parse price strings like "118,86€"
function parsePrice(priceStr) {
  if (!priceStr) return 0;
  return parseFloat(priceStr.replace(/[^\d,.-]/g, "").replace(",", ".")) || 0;
}

// Utility to format number into "118,86€"
function formatCurrency(num) {
  return num.toFixed(2).replace(".", ",") + "€";
}


function updateSelectedCount() {
  const counter = document.getElementById("selected-count");
  if (counter) {
    counter.textContent = selectedVariantIds.length;
  }
}

showSlots(4);

// function formatCurrency(num) {
//   return num.toFixed(2).replace(".", ",") + "€";
// }

// function parsePrice(priceStr) {
//   if (!priceStr) return 0;
//   return parseFloat(priceStr.replace(/[^\d,.-]/g, "").replace(",", ".")) || 0;
// }

function updatePackPrices() {
  const activeOption = document.querySelector(".pack-option.active");
  if (!activeOption) return;

  const selectedMainPrice = parsePrice(
    activeOption.getAttribute("data-main-price")
  );
  const selectedSalePrice = parsePrice(
    activeOption.getAttribute("data-sale-price")
  );

  const packMainPrice = document.getElementById("pack-original-price");
  const packSalePrice = document.getElementById("pack-discounted-price");
  const packSaveValue = document.getElementById("pack-footer-save-value");

  if (packMainPrice)
    packMainPrice.innerText = activeOption.getAttribute("data-main-price");
  if (packSalePrice)
    packSalePrice.innerText = activeOption.getAttribute("data-sale-price");

  const saveAmount = selectedMainPrice - selectedSalePrice;
  const newSave = saveAmount.toFixed(2).replace(".", ",");
  
  if (packSaveValue) packSaveValue.innerText = "-" + newSave + "€";
}

updatePackPrices();

function updateQtyButtonState() {
  const limit = parseInt(mainPack.getAttribute("data-selected-pack"), 10);
  const totalSelected = selectedVariantIds.length;

  document.querySelectorAll(".bundle-builder--inputs-container").forEach(container => {
    const plusBtn = container.querySelector(".add-on-qty-plus");
    const minusBtn = container.querySelector(".add-on-qty-minus");
    const input = container.querySelector(".quantity-selector__input");
    const currentVal = parseInt(input.value, 10) || 0;

    // Disable plus if total already at limit
    if (totalSelected >= limit) {
      plusBtn.setAttribute("disabled", "true");
      plusBtn.style.opacity = 0.5;
    } else {
      plusBtn.removeAttribute("disabled");
      plusBtn.style.opacity = 1;
    }

    // Disable minus if 0 qty
    if (currentVal <= 0) {
      minusBtn.setAttribute("disabled", "true");
      minusBtn.style.opacity = 0.5;
    } else {
      minusBtn.removeAttribute("disabled");
      minusBtn.style.opacity = 1;
    }
  });
}

// ---------- qty buttons (plus / minus) ----------
variantPackQty.forEach((btn) => {
  btn.addEventListener("click", function () {
    const input = btn.parentElement.querySelector(".quantity-selector__input");
    const productCard = btn.closest(".product-card__info");
    const addOnBundleBuilder = productCard.querySelector(".bundle-builder--inputs-container");
    const addOnBundleBtn = productCard.querySelector(".custom-addon-pack");
    const limit = parseInt(mainPack.getAttribute("data-selected-pack"), 10);

    // prefer the builder/input/button attributes (safest)
    const variantId =
      (addOnBundleBuilder && addOnBundleBuilder.getAttribute("data-variant-id")) ||
      (input && input.getAttribute("data-variant-id")) ||
      (addOnBundleBtn && addOnBundleBtn.getAttribute("data-variant-id")) ||
      null;

    const variantImg = (addOnBundleBtn && addOnBundleBtn.getAttribute("data-variant-img")) || "";

    // IMPORTANT: read prices from input first (set on variant-change), fallback to builder/button
    const variantPrice =
      (input && input.getAttribute("data-price")) ||
      (addOnBundleBuilder && addOnBundleBuilder.getAttribute("data-price")) ||
      (addOnBundleBtn && addOnBundleBtn.getAttribute("data-price")) ||
      "0";

    const variantComparePrice =
      (input && input.getAttribute("data-compare-price")) ||
      (addOnBundleBuilder && addOnBundleBuilder.getAttribute("data-compare-price")) ||
      (addOnBundleBtn && addOnBundleBtn.getAttribute("data-compare-price")) ||
      "0";

    let currentVal = parseInt(input.value, 10) || 0;

    if (btn.classList.contains("add-on-qty-plus")) {
      // add
      if (selectedVariantIds.length < limit) {
        currentVal += 1;
        input.value = currentVal;

        if (addOnBundleBuilder) addOnBundleBuilder.classList.remove("hidden");
        if (addOnBundleBtn) addOnBundleBtn.style.display = "none";

        // create one slot and put price attrs on the remove button (custom-remove-pack)
        addSlotWithPrice(variantId, variantImg, variantPrice, variantComparePrice);
      }
    } else if (btn.classList.contains("add-on-qty-minus")) {
      // remove
      if (currentVal > 0) {
        currentVal -= 1;
        input.value = currentVal;

        removeSlotsForVariant(variantId, 1);

        if (currentVal === 0) {
          if (addOnBundleBuilder) addOnBundleBuilder.classList.add("hidden");
          if (addOnBundleBtn) addOnBundleBtn.style.display = "block";
        }
      }
    }

    // update UI state + totals
    updateAddonButtonState();
    updateQtyButtonState();
    recalcBundleTotals();
    // keep existing jQuery show call if you rely on it
    $(".bundle-pack__slots").show();
  });
});


// ---------- slot creation which writes price onto .custom-remove-pack ----------
function addSlotWithPrice(variantId, variantImg, variantPrice, variantComparePrice) {
  if (!variantId) return; // safety
  const limit = parseInt(mainPack.getAttribute("data-selected-pack"), 10);
  if (selectedVariantIds.length >= limit) return;

  const emptySlotIndex = Array.from(slots).findIndex((s) => !s.hasAttribute("data-variant-id"));
  if (emptySlotIndex === -1) return;

  // reserve the slot and push tracking object
  selectedVariantIds.push({ id: variantId, slot: emptySlotIndex });

  const slot = slots[emptySlotIndex];
  slot.setAttribute("data-variant-id", variantId);

  // put price info ON THE REMOVE BUTTON as requested
  slot.innerHTML = `
    <div class="custom-remove-pack"
         data-variant-id="${variantId}"
         data-slot-index="${emptySlotIndex}"
         data-price="${variantPrice}"
         data-compare-price="${variantComparePrice}">
      <svg class="custom-remove-pack-svg" role="presentation" stroke-width="2" width="20" height="20" viewBox="0 0 24 24">
        <path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor"></path>
      </svg>
    </div>
    <div class="custom-pack-img-wrapper">
      <img class="custom-pack-img" src="${variantImg}" alt="" />
    </div>`;

  // update UI helpers
  updateSelectedCount();
  updateAddonButtonState();
  updateQtyButtonState();
  recalcBundleTotals();
  $(".bundle-pack__slots").show();
}

function addSlotsForVariant(variantId, variantImg, qty) {
  const limit = parseInt(mainPack.getAttribute("data-selected-pack"), 10);

  for (let i = 0; i < qty; i++) {
    if (selectedVariantIds.length >= limit) return;

    let emptySlotIndex = Array.from(slots).findIndex(
      (s) => !s.hasAttribute("data-variant-id")
    );

    if (emptySlotIndex > -1) {
      selectedVariantIds.push({ id: variantId, slot: emptySlotIndex });

      const slot = slots[emptySlotIndex];
      slot.setAttribute("data-variant-id", variantId);
      slot.innerHTML = `
        <div class="custom-remove-pack" data-variant-id="${variantId}" data-slot-index="${emptySlotIndex}">
          <svg class="custom-remove-pack-svg" role="presentation" stroke-width="2" width="20" height="20" viewBox="0 0 24 24">
            <path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor"></path>
          </svg>
        </div>
        <div class="custom-pack-img-wrapper">
          <img class="custom-pack-img" src="${variantImg}" alt="" />
        </div>`;
    }
  }

  updateAddonButtonState();
  updateSelectedCount();
  updateQtyButtonState();
}
function removeSlotsForVariant(variantId, qty) {
  for (let i = 0; i < qty; i++) {
    const index = selectedVariantIds.findIndex((entry) => entry.id === variantId);
    if (index > -1) {
      const slotIndex = selectedVariantIds[index].slot;
      selectedVariantIds.splice(index, 1);

      const slot = slots[slotIndex];
      if (slot) {
        slot.removeAttribute("data-variant-id");
        slot.innerHTML = `<button class="bundle-pack__add custom-pack-img-wrapper" type="button"><span>+</span></button>`;
      }
    }
  }

  updateAddonButtonState();
  updateSelectedCount();
  updateQtyButtonState();
  recalcBundleTotals();
}

const variantPackSelects = document.querySelectorAll(".custom-pack-variant-select");

function updatevariantPackoption() {
  variantPackSelects.forEach((select) => {
    select.addEventListener("change", function () {
      const addonID = this.value; // selected variant id
      const mainPrice = this.options[this.selectedIndex].getAttribute("data-price");
      const comparePrice = this.options[this.selectedIndex].getAttribute("data-compare-price");
      const productCard = this.closest(".product-card__info");
      const addOnBtn = productCard.querySelector(".custom-addon-pack");
      const addOnBundleBuilder = productCard.querySelector(".bundle-builder--inputs-container");
      const qtyInput = productCard.querySelector(".quantity-selector__input");

      if (addOnBtn) {
        addOnBtn.setAttribute("data-variant-id", addonID);
        addOnBtn.setAttribute("data-price", mainPrice);
        addOnBtn.setAttribute("data-compare-price", comparePrice || "");
      }
      if (addOnBundleBuilder) {
        addOnBundleBuilder.setAttribute("data-variant-id", addonID);
        addOnBundleBuilder.setAttribute("data-price", mainPrice);
        addOnBundleBuilder.setAttribute("data-compare-price", comparePrice || "");
      }
      
      if (qtyInput) {
        qtyInput.setAttribute("data-variant-id", addonID);
        qtyInput.setAttribute("data-price", mainPrice);
        qtyInput.setAttribute("data-compare-price", comparePrice);
      }

      const priceList = productCard.querySelector("price-list");
      if (priceList) {
        const salePriceEl = priceList.querySelector("sale-price");
        const comparePriceEl = priceList.querySelector("compare-at-price");
        const existingBadge = priceList.querySelector("on-sale-badge");

        // remove old badge
        if (existingBadge) existingBadge.remove();

        // set sale price
        if (salePriceEl) {
          salePriceEl.innerHTML = `<span class="sr-only">Prix de vente</span>${mainPrice}`;
        }

        // set compare-at price (if exists)
        if (comparePrice && comparePriceEl) {
          comparePriceEl.innerHTML = `<span class="sr-only">Prix normal</span>${comparePrice}`;

          // calculate discount
          const priceNum = parseFloat(mainPrice.replace(",", ".").replace(/[^\d.]/g, "")) || 0;
          const compareNum = parseFloat(comparePrice.replace(",", ".").replace(/[^\d.]/g, "")) || 0;

          if (compareNum > priceNum) {
            const discountPercent = Math.round(((compareNum - priceNum) / compareNum) * 100);
            const badge = document.createElement("on-sale-badge");
            badge.className = "badge badge--on-sale";
            badge.textContent = `-${discountPercent}%`;
            priceList.appendChild(badge);
          }
        } else if (comparePriceEl) {
          // clear compare price if no compare-at
          comparePriceEl.innerHTML = `<span class="sr-only">Prix normal</span>`;
        }
      }
    });
  });
}

// init
updatevariantPackoption();

mainPackoptions.forEach((packOption) => {
  packOption.addEventListener("click", function () {
    mainPackoptions.forEach((option) => option.classList.remove("active"));
    this.classList.add("active");

    addOnButton.forEach((btn) => {
      // btn.classList.remove("active-addon");
      btn.innerText = "Sélectionner";
      btn.removeAttribute("disabled");
      btn.style.display = "block";
    });

    document.querySelectorAll(".bundle-builder--inputs-container").forEach((builder) => {
      builder.classList.add("hidden"); // hide qty input container
      builder.removeAttribute("data-variant-id"); // clear variant id
      const input = builder.querySelector(".quantity-selector__input");
      if (input) input.value = 0; // reset value
    });

    const selectedQty = this.getAttribute("data-pack-qty");
    const selectedQtyDiscount = this.getAttribute("data-pack-discount");

    packMainPrice.innerText = this.getAttribute("data-main-price");
    packSalePrice.innerText = this.getAttribute("data-sale-price");

    slots.forEach((slot) => {
      slot.removeAttribute("data-variant-id");
      slot.innerHTML = `<button class="bundle-pack__add custom-pack-img-wrapper" type="button"><span>+</span></button>`;
    });

    packCheckout.innerText = "Sélectionne " + selectedQty + " produits";
    packCheckout.classList.remove("active");
    selectedVariantIds = []; // reset all

    mainPack.setAttribute("data-selected-pack", selectedQty);

    gridPackTitle.innerText = gridPackTitle.innerText.replace(/\d+/, selectedQty);
    stickyPackTitle.innerText = stickyPackTitle.innerText.replace(/\d+/, selectedQty);
    stickyInitial.innerText = stickyInitial.innerText.replace(/\d+/, selectedQty);
    packCheckout.innerText = packCheckout.innerText.replace(/\d+/, selectedQty);
    packDiscount.innerText = selectedQtyDiscount;

    showSlots(parseInt(selectedQty, 10));
    updateSelectedCount();
    updatePackPrices();
    updateAddonButtonState();
    updatevariantPackoption();
    updateQtyButtonState();

  });
});

// ---------------- ADD ----------------
const addOnButton = document.querySelectorAll(".custom-addon-pack");

addOnButton.forEach((btn) => {
  btn.addEventListener("click", function () {

    this.style.display = "none";

    const variantId = this.getAttribute("data-variant-id");
    const variantImg = this.getAttribute("data-variant-img");
    const variantPrice = this.getAttribute("data-price");
    const variantCompareprice = this.getAttribute("data-compare-price");
    const limit = parseInt(mainPack.getAttribute("data-selected-pack"), 10);

    const productCard = this.closest(".product-card__info");
    const bundleInput = productCard.querySelector(".bundle-builder--inputs-container");
    const bundleInputValue = productCard.querySelector(".quantity-selector__input");
    
    if(bundleInputValue){ bundleInputValue.value = 1; }
    if(bundleInput){ bundleInput.classList.remove("hidden"); }

    if (selectedVariantIds.length >= limit) return;

    // find first empty slot
    let emptySlotIndex = Array.from(slots).findIndex(
      (s) => !s.hasAttribute("data-variant-id")
    );

    if (emptySlotIndex > -1) {
      // push object instead of plain id
      selectedVariantIds.push({ id: variantId, slot: emptySlotIndex });

      const slot = slots[emptySlotIndex];
      slot.setAttribute("data-variant-id", variantId);
      slot.innerHTML = `
        <div class="custom-remove-pack" data-variant-id="${variantId}" data-slot-index="${emptySlotIndex}" data-price="${variantPrice}" data-compare-price="${variantCompareprice}"
        >
          <svg class="custom-remove-pack-svg" role="presentation" stroke-width="2" width="20" height="20" viewBox="0 0 24 24">
            <path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor"></path>
          </svg>
        </div>
        <div class="custom-pack-img-wrapper">
          <img class="custom-pack-img" src="${variantImg}" alt="" />
        </div>`;
    }

    updateAddonButtonState();
    updateQtyButtonState();
    recalcBundleTotals();
    $('.bundle-pack__slots').show();
  });
});


const slotsContainer = document.querySelector('.bundle-pack__slots') || document; // fallback to document

slotsContainer.addEventListener('click', function (e) {
  const removeBtn = e.target.closest('.custom-remove-pack');
  if (!removeBtn) return;

  const rmvID = removeBtn.getAttribute('data-variant-id');
  const rmvSlot = parseInt(removeBtn.getAttribute('data-slot-index'), 10);

  // 1) remove this slot entry from selectedVariantIds (match by slot index)
  const index = selectedVariantIds.findIndex(
    (entry) => entry.slot === rmvSlot && entry.id === rmvID
  );
  if (index > -1) selectedVariantIds.splice(index, 1);

  // 2) clear this slot visually (use the slots NodeList so we target the correct slot)
  const slotEl = slots[rmvSlot];
  if (slotEl) {
    slotEl.removeAttribute('data-variant-id');
    slotEl.innerHTML = `<button class="bundle-pack__add custom-pack-img-wrapper" type="button"><span>+</span></button>`;
  }

  // 3) decrement the corresponding product's qty input by 1 (if exists)
  const productCard = document.querySelector(
    `.bundle-builder--inputs-container[data-variant-id="${rmvID}"]`
  );
  if (productCard) {
    const input = productCard.querySelector('.quantity-selector__input');
    let val = parseInt(input.value, 10) || 0;
    if (val > 0) {
      input.value = val - 1;
    }

    // if qty becomes 0 -> hide builder and show "Sélectionner" button
    if (parseInt(input.value, 10) === 0) {
      productCard.classList.add('hidden');
      const addBtn = productCard
        .closest('.product-card__info')
        .querySelector('.custom-addon-pack');
      if (addBtn) addBtn.style.display = 'block';
    }
  }

  // 4) re-sync UI state
  updateAddonButtonState();
  updateSelectedCount();
  updateQtyButtonState();
  recalcBundleTotals();
});


function updateAddonButtonState() {
  const limit = parseInt(mainPack.getAttribute("data-selected-pack"), 10);
  const remaining = limit - selectedVariantIds.length;

  if (remaining === 0) {
    packCheckout.classList.add("active");
    packCheckout.innerText = "Ajouter au panier";
    addOnButton.forEach((btn) => btn.setAttribute("disabled", "true"));
    addOnButton.forEach((btn) => btn.style.opacity = 0.7);
    addOnButton.forEach((btn) => btn.classList.add = "disabled");
  } else {
    packCheckout.classList.remove("active");
    packCheckout.innerText =
      "Sélectionne " + remaining + " produit" + (remaining > 1 ? "s" : "");
    addOnButton.forEach((btn) => btn.removeAttribute("disabled"));
    addOnButton.forEach((btn) => btn.style.opacity = 1);
    addOnButton.forEach((btn) => btn.classList.remove = "disabled");
  }

  updateSelectedCount();
}


const stickyATCbtn = document.getElementById("bundle-pack__checkout");

if (stickyATCbtn) {
  stickyATCbtn.addEventListener("click", async function (event) {
    event.preventDefault();
    if (!this.classList.contains("active")) return;

    // ✅ build variant → qty map from slots
    const variantCounts = {};
    selectedVariantIds.forEach(entry => {
      if (!entry.id) return;
      variantCounts[entry.id] = (variantCounts[entry.id] || 0) + 1;
    });

    const items = Object.entries(variantCounts).map(([id, quantity]) => ({
      id: parseInt(id, 10),
      quantity
    }));

    if (!items.length) return;

    // cart drawer logic stays the same
    const cartDrawerEl = document.getElementById("cart-drawer");
    const cartDrawerSectionId = cartDrawerEl ? extractSectionId(cartDrawerEl) : null;

    const sectionsToRender = [];
    if (cartDrawerSectionId) sectionsToRender.push(cartDrawerSectionId);

    // just pick first variant for `sections_url` (not last one!)
    const sectionsParam = sectionsToRender.join(",");
    const sectionsUrl = `${window.Shopify.routes.root}variants/${items[0].id}`;

    try {
      const addRes = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items,
          sections: sectionsParam,
          sections_url: sectionsUrl
        })
      });

      if (!addRes.ok) {
        const err = await addRes.json().catch(() => ({}));
        throw new Error(err.message || "Failed to add to cart");
      }

      const addData = await addRes.json();
      const cart = await fetch("/cart.js").then(r => r.json());
      const cartWithSections = { ...cart, sections: addData.sections || {} };

      document.dispatchEvent(new CustomEvent("cart:change", {
        detail: {
          cart: cartWithSections,
          baseEvent: "variant:add"
        }
      }));

      if (cartDrawerEl) {
        if (typeof cartDrawerEl.show === "function") {
          cartDrawerEl.show();
        } else {
          Object.assign(cartDrawerEl.style, {
            left: "auto",
            right: "0px",
            top: "0px",
            opacity: "1",
            visibility: "visible"
          });
          cartDrawerEl.setAttribute("open", "true");
          cartDrawerEl.classList.add("show-close-cursor");
          document.documentElement.classList.add("lock");
        }
      }

      // ✅ reset bundle state after adding
      selectedVariantIds = [];
      slots.forEach(slot => {
        slot.removeAttribute("data-variant-id");
        slot.innerHTML = `<button class="bundle-pack__add custom-pack-img-wrapper" type="button"><span>+</span></button>`;
      });

      document.querySelectorAll(".bundle-builder--inputs-container").forEach(builder => {
        builder.classList.add("hidden");
        builder.removeAttribute("data-variant-id");
        const input = builder.querySelector(".quantity-selector__input");
        if (input) input.value = 0;
      });

      addOnButton.forEach(btn => {
        btn.innerText = "Sélectionner";
        btn.removeAttribute("disabled");
        btn.style.opacity = 1;
        btn.style.display = "block";
      });

      const packLimit = parseInt(mainPack.getAttribute("data-selected-pack"), 10);
      packCheckout.classList.remove("active");
      packCheckout.innerText = "Sélectionne " + packLimit + " produits";

      updateSelectedCount();
      updateAddonButtonState();
      updateQtyButtonState();
      updatePackPrices();
      updatevariantPackoption();

    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  });
}


// if (stickyATCbtn) {
//   stickyATCbtn.addEventListener("click", async function (event) {
//     event.preventDefault();
//     if (!this.classList.contains("active")) return;

//     // const variantIds = (selectedVariantIds || [])
//     //   .map(entry => parseInt(entry.id, 10)) // use entry.id, not whole object
//     //   .filter(Boolean);

//       selectedVariantIds = [];
//   document.querySelectorAll(".bundle-builder--inputs-container:not(.hidden)").forEach(builder => {
//     const input = builder.querySelector(".quantity-selector__input");
//     const variantId = builder.getAttribute("data-variant-id");
//     const qty = parseInt(input?.value, 10) || 0;

//     if (variantId && qty > 0) {
//       for (let i = 0; i < qty; i++) {
//         selectedVariantIds.push({ id: variantId });
//       }
//     }
//   });

//   const variantIds = selectedVariantIds.map(entry => parseInt(entry.id, 10)).filter(Boolean);

//     if (!variantIds.length) return;

//     const items = variantIds.map(id => ({ id, quantity: 1 }));
//     const cartDrawerEl = document.getElementById("cart-drawer");
//     const cartDrawerSectionId = cartDrawerEl ? extractSectionId(cartDrawerEl) : null;

//     const sectionsToRender = [];
//     if (cartDrawerSectionId) sectionsToRender.push(cartDrawerSectionId);

//     const lastVariantId = variantIds[variantIds.length - 1];
//     const sectionsParam = sectionsToRender.join(",");
//     const sectionsUrl = `${window.Shopify.routes.root}variants/${lastVariantId}`;

//     try {
//       const addRes = await fetch("/cart/add.js", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           items,
//           sections: sectionsParam,    
//           sections_url: sectionsUrl
//         })
//       });

//       if (!addRes.ok) {
//         const err = await addRes.json().catch(() => ({}));
//         throw new Error(err.message || "Failed to add to cart");
//       }

//       const addData = await addRes.json(); 
//       const cart = await fetch("/cart.js").then(r => r.json());

//       const cartWithSections = { ...cart, sections: addData.sections || {} };

//       document.dispatchEvent(new CustomEvent("cart:change", {
//         detail: {
//           cart: cartWithSections,
//           baseEvent: "variant:add"
//         }
//       }));

//       if (cartDrawerEl) {
//         if (typeof cartDrawerEl.show === "function") {
//           cartDrawerEl.show();
//         } else {
//           Object.assign(cartDrawerEl.style, {
//             left: "auto",
//             right: "0px",
//             top: "0px",
//             opacity: "1",
//             visibility: "visible"
//           });
//           cartDrawerEl.setAttribute("open", "true");
//           cartDrawerEl.classList.add("show-close-cursor");
//           document.documentElement.classList.add("lock")
//         }
//       }

//             selectedVariantIds = [];

//       // reset slots
//       slots.forEach((slot) => {
//         slot.removeAttribute("data-variant-id");
//         slot.innerHTML = `<button class="bundle-pack__add custom-pack-img-wrapper" type="button"><span>+</span></button>`;
//       });

//       // reset qty inputs & builders
//       document.querySelectorAll(".bundle-builder--inputs-container").forEach((builder) => {
//         builder.classList.add("hidden");
//         builder.removeAttribute("data-variant-id");
//         const input = builder.querySelector(".quantity-selector__input");
//         if (input) input.value = 0;
//       });

//       // reset addon buttons
//       addOnButton.forEach((btn) => {
//         btn.innerText = "Sélectionner";
//         btn.removeAttribute("disabled");
//         btn.style.opacity = 1;
//         btn.style.display = "block";
//       });

//       // reset checkout button
//       const packLimit = parseInt(mainPack.getAttribute("data-selected-pack"), 10);
//       packCheckout.classList.remove("active");
//       packCheckout.innerText = "Sélectionne " + packLimit + " produits";

//       // re-sync all UI
//       updateSelectedCount();
//       updateAddonButtonState();
//       updateQtyButtonState();
//       updatePackPrices();
//       updatevariantPackoption();

//     } catch (error) {
//       console.error("Error adding to cart:", error);
//     }
//   });
// }

function extractSectionId(element) {
  if (!element) return null;
  const sectionEl = element.classList?.contains("shopify-section")
    ? element
    : element.closest(".shopify-section");
  if (!sectionEl) return null;
  return sectionEl.id.startsWith("shopify-section-")
    ? sectionEl.id.replace("shopify-section-", "")
    : sectionEl.id;
}

//----------------------------------------------------------------//

// PRODUCT PACK JS STARTS

const flavorPack = document.getElementById("flavor-pack-step");
const formatPack = document.getElementById("format-pack-step");
const addOnPack = document.getElementById("addon-pack-step");

const pdpPackAdd = document.querySelectorAll(".product-pack-button");
const pdpFormatAdd = document.querySelectorAll(".product-format-button");
const pdpAddOn = document.querySelectorAll(".product-addon-button");

const setpOneBtn = document.getElementById("product-pack-step-1-btn");
const setpTwoBtn = document.getElementById("product-pack-step-2-btn");
const setpThreeBtn = document.getElementById("product-pack-step-3-btn");

const step1next = document.getElementById("step1-next");
const step2next = document.getElementById("step2-next");
const step2back = document.getElementById("step2-back");
const step3back = document.getElementById("step3-back");

    if(flavorPack.getAttribute("data-pack-type") == "recovery-pack"){
      console.log("recovery-pack");
      

      let addedVariantIds = [];
      const limit = 2;

    pdpPackAdd.forEach(addbtn => {
      addbtn.addEventListener("click", function () {
        const varID = addbtn.getAttribute("data-variant-id");

        if (addedVariantIds.includes(varID)) {
          addedVariantIds = addedVariantIds.filter(id => id !== varID);
          addbtn.classList.remove("active");
          addbtn.innerText = "AJOUTER";
        } else {
          if (addedVariantIds.length < limit) {
            addedVariantIds.push(varID);
            addbtn.classList.add("active");
            addbtn.innerText = "AJOUTÉ";
          }
        }

          if (addedVariantIds.length === limit) {
            if(setpOneBtn){
              setpOneBtn.removeAttribute("disabled");
              setpOneBtn.setAttribute("enabled", "enabled");
              setpOneBtn.classList.add("active");
              // step1next.classList.add("active");
            }
          } else {
            if(setpOneBtn){
              setpOneBtn.setAttribute("disabled", "disabled");
              setpOneBtn.removeAttribute("enabled");
              setpOneBtn.classList.remove("active");
              // step1next.classList.remove("active");
            }
          }

      });
    });

      async function addRecoveryPack() {
        const items = [];

        const Recoverinputs = document.querySelectorAll(".recovery-pack-input");
        const mainAddon = document.querySelectorAll(".product-pack-button");

        // Add recovery inputs
        Recoverinputs.forEach(recinput => {
          if (recinput.value) {
            items.push({ 
              id: recinput.value, 
              quantity: 1,
              properties: {
                  "Pack type": "Recovery pack"
                } 
            });
          }
        });

        // Add active addons
        mainAddon.forEach(addId => {
          if (addId.classList.contains("active")) {
            const variantId = addId.getAttribute("data-variant-id");
            if (variantId) {
              items.push({ 
                id: variantId, 
                quantity: 1,
                properties: {
                  "Pack type": "Recovery pack"
                } 
              });
            }
          }
        });

        const cartDrawerEl = document.getElementById("cart-drawer");
        const cartDrawerSectionId = cartDrawerEl ? extractSectionId(cartDrawerEl) : null;

        const sectionsToRender = [];
        if (cartDrawerSectionId) sectionsToRender.push(cartDrawerSectionId);

        const sectionsParam = sectionsToRender.join(",");
        const lastVariantId = (addedVariantIds[addedVariantIds.length - 1] || variantAddon[0]);
        const sectionsUrl = `${window.Shopify.routes.root}variants/${lastVariantId}`;

        try {
          const addRes = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              items,
              sections: sectionsParam,
              sections_url: sectionsUrl
            })
          });

          if (!addRes.ok) {
            const err = await addRes.json().catch(() => ({}));
            throw new Error(err.message || "Failed to add to cart");
          }

          const addData = await addRes.json();
          const cart = await fetch("/cart.js").then(r => r.json());
          const cartWithSections = { ...cart, sections: addData.sections || {} };

          document.dispatchEvent(new CustomEvent("cart:change", {
            detail: { cart: cartWithSections, baseEvent: "variant:add" }
          }));

          if (cartDrawerEl) {
            if (typeof cartDrawerEl.show === "function") {
              cartDrawerEl.show();
            } else {
              Object.assign(cartDrawerEl.style, {
                left: "auto",
                right: "0px",
                top: "0px",
                opacity: "1",
                visibility: "visible"
              });
              cartDrawerEl.setAttribute("open", "true");
              cartDrawerEl.classList.add("show-close-cursor");
              document.documentElement.classList.add("lock");
            }
          }
        } catch (error) {
          console.error("Add to cart failed:", error);
        }
      }

    setpOneBtn.addEventListener("click", function () {
      if(this.classList.contains("active")){
        // flavorPack.classList.add("hidden");

        const packType = this.getAttribute("data-pack-type");
          if (packType === "recovery-pack") {
            addRecoveryPack();
          } else {

          }
        
        // formatPack.classList.remove("hidden");
        // step2back.classList.add("active");
      } else {
        // flavorPack.classList.remove("hidden");
        // formatPack.classList.add("hidden");
        // step2back.classList.remove("active");
      }
    });

    } else {

      async function addProtienPack() {

        const items = [];

        document.querySelectorAll(".product-pack-button.active").forEach(btn => {
          const variantId = btn.getAttribute("data-variant-id");
          if (variantId) {
            items.push({ 
              id: variantId, 
              quantity: 1,
              properties: { "Pack type": "Protein + Post Workout Pack" }
            });
          }
        });

        document.querySelectorAll(".product-format-button.active").forEach(btn => {
          const variantId = btn.getAttribute("data-variant-id");
          if (variantId) {
            items.push({ 
              id: variantId, 
              quantity: 1,
              properties: { "Pack type": "Protein + Post Workout Pack" }
            });
          }
        });

        document.querySelectorAll(".protien-and-post-workout-pack-input").forEach(input => {
          if (input.value) {
            items.push({ 
              id: input.value, 
              quantity: 1,
              properties: { "Pack type": "Protein + Post Workout Pack" }
            });
          }
        });

        const cartDrawerEl = document.getElementById("cart-drawer");
        const cartDrawerSectionId = cartDrawerEl ? extractSectionId(cartDrawerEl) : null;

        const sectionsToRender = [];
        if (cartDrawerSectionId) sectionsToRender.push(cartDrawerSectionId);

        const sectionsParam = sectionsToRender.join(",");
        const lastVariantId = (addedVariantIds[addedVariantIds.length - 1] || variantAddon[0]);
        const sectionsUrl = `${window.Shopify.routes.root}variants/${lastVariantId}`;

        try {
          const addRes = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              items,
              sections: sectionsParam,
              sections_url: sectionsUrl
            })
          });

          if (!addRes.ok) {
            const err = await addRes.json().catch(() => ({}));
            throw new Error(err.message || "Failed to add to cart");
          }

          const addData = await addRes.json();
          const cart = await fetch("/cart.js").then(r => r.json());
          const cartWithSections = { ...cart, sections: addData.sections || {} };

          document.dispatchEvent(new CustomEvent("cart:change", {
            detail: { cart: cartWithSections, baseEvent: "variant:add" }
          }));

          if (cartDrawerEl) {
            if (typeof cartDrawerEl.show === "function") {
              cartDrawerEl.show();
            } else {
              Object.assign(cartDrawerEl.style, {
                left: "auto",
                right: "0px",
                top: "0px",
                opacity: "1",
                visibility: "visible"
              });
              cartDrawerEl.setAttribute("open", "true");
              cartDrawerEl.classList.add("show-close-cursor");
              document.documentElement.classList.add("lock");
            }
          }
        } catch (error) {
          console.error("Add to cart failed:", error);
        }
      }

    setpOneBtn.addEventListener("click", function () {
      if(this.classList.contains("active")){
        flavorPack.classList.add("hidden");
        formatPack.classList.remove("hidden");
        step2back.classList.add("active");
      } else {
        flavorPack.classList.remove("hidden");
        formatPack.classList.add("hidden");
        step2back.classList.remove("active");
      }
    });

    if(step1next){
      step1next.addEventListener("click", function () {
        if(this.classList.contains("active")){
          formatPack.classList.remove("hidden");
          flavorPack.classList.add("hidden");
          step2back.classList.add("active");
          // step3back.classList.add("active");
        } else {
          formatPack.classList.add("hidden");
          flavorPack.classList.remove("hidden");
        }
      });
    }

    step2back.addEventListener("click", function () {
      if(this.classList.contains("active")){
        flavorPack.classList.remove("hidden");
        formatPack.classList.add("hidden");
        step2back.classList.add("active");
      } else {
        flavorPack.classList.add("hidden");
        formatPack.classList.remove("hidden");
      }
    });

    let addedVariantIds = [];
    const limit = 1;

    pdpPackAdd.forEach(addbtn => {
      addbtn.addEventListener("click", function () {
        const varID = addbtn.getAttribute("data-variant-id");

        if (addedVariantIds.includes(varID)) {
          addedVariantIds = addedVariantIds.filter(id => id !== varID);
          addbtn.classList.remove("active");
          addbtn.innerText = "AJOUTER";
        } else {
          if (addedVariantIds.length < limit) {
            addedVariantIds.push(varID);
            addbtn.classList.add("active");
            addbtn.innerText = "AJOUTÉ";
          }
        }

          if (addedVariantIds.length === limit) {
            if(setpOneBtn){
              setpOneBtn.removeAttribute("disabled");
              setpOneBtn.setAttribute("enabled", "enabled");
              setpOneBtn.classList.add("active");
              step1next.classList.add("active");
            }
          } else {
            if(setpOneBtn){
              setpOneBtn.setAttribute("disabled", "disabled");
              setpOneBtn.removeAttribute("enabled");
              setpOneBtn.classList.remove("active");
              step1next.classList.remove("active");
            }
          }

      });
    });

    let addedVariantFormat = [];
    const formatlimit = 1;

    pdpFormatAdd.forEach(addbtn => {
      addbtn.addEventListener("click", function () {
        const varformat = addbtn.getAttribute("data-variant-id");

        if (addedVariantFormat.includes(varformat)) {
          addedVariantFormat = addedVariantFormat.filter(id => id !== varformat);
          addbtn.classList.remove("active");
          addbtn.innerText = "AJOUTER";
        } else {
          if (addedVariantFormat.length < formatlimit) {
            addedVariantFormat.push(varformat);
            addbtn.classList.add("active");
            addbtn.innerText = "AJOUTÉ";
          }
        }

        if (addedVariantFormat.length === formatlimit) {
          setpTwoBtn.removeAttribute("disabled");
          setpTwoBtn.setAttribute("enabled", "enabled");
          setpTwoBtn.classList.add("active");
          // step2next.classList.add("active");
        } else {
          setpTwoBtn.setAttribute("disabled", "disabled");
          setpTwoBtn.removeAttribute("enabled");
          setpTwoBtn.classList.remove("active");
          // step2next.classList.remove("active");
        }

      });
    });

    setpTwoBtn.addEventListener("click", function () {
      if(this.classList.contains("active")){
        const packType = this.getAttribute("data-pack-type");
        if (packType == "protien-and-post-workout-pack") {
          addProtienPack();
        } 
      } 
    });

}
